/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-undef */
import { classNames } from 'shared/lib/classNames/classNames';
import React, { ReactNode, useEffect, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Text, TextSize } from 'shared/ui/Text/Text';
import img from 'shared/assets/img/pages/girl-image.png';
import CardPlug from 'shared/assets/img/pages/card-plug.png';
import Cart from 'shared/assets/icons/Cart.svg';
import Minus from 'shared/assets/icons/minus.svg';
import Plus from 'shared/assets/icons/plus.svg';
import Rubish from 'shared/assets/icons/rubish.svg';
import Safe from 'shared/assets/icons/Policy/safe.svg';
import Percent from 'shared/assets/icons/Policy/percent.svg';
import Calculator from 'shared/assets/icons/Policy/calculator.svg';
import Heart from 'shared/assets/icons/Policy/heart.svg';
import HousePercent from 'shared/assets/icons/Policy/house_percent.svg';
import Rub from 'shared/assets/icons/Policy/rub.svg';
import CardOnCard from 'shared/assets/icons/Policy/card_on_card.svg';
import BarGraph from 'shared/assets/icons/Policy/bar_graph.svg';
import Document from 'shared/assets/icons/Policy/document.svg';
import Briefcase from 'shared/assets/icons/Policy/briefcase.svg';
import { useApi } from 'app/api/APIProvider';
import cls from './PolicyWork.module.scss';

interface ICard {
    text: string,
    iconIndex: number,
}


interface PolicyWorkdsProps {
    cards: ICard[],
}

const icons = {
    1: <Safe />,
    2: <Percent />,
    3: <Calculator />,
    4: <Heart />,
    5: <HousePercent />,
    6: <Rub />,
    7: <CardOnCard />,
    8: <BarGraph />,
    9: <Document />,
    10: <Briefcase />,
}

export const PolicyWork = ({ cards }: PolicyWorkdsProps) => {
    const api = useApi();

    return (
        <div className={cls.cardsWrapper}>
            {
                cards.map(({ text, iconIndex }, index) => {
                    return (
                        <div className={cls.work} key={index}>
                            <div className={cls.imgBox}>
                                {
                                    //@ts-ignore
                                    icons[iconIndex]
                                }
                            </div>
                            <Text className={cls.text} color="#000" size={TextSize.text_16}>
                                {text}
                            </Text>
                        </div>
                    );
                })
            }
        </div>
    );
};

